import React, { useCallback, useEffect, useState } from 'react';
import { Loader2, Plus, Siren, ChevronRight } from 'lucide-react';
import { haccpApi, dataIt } from '../haccpApi';
import { NuovoRichiamo } from './NuovoRichiamo';
import { RichiamoDettaglio } from './RichiamoDettaglio';
import { preparazioni } from './BadgeRichiamo';

const Card = ({ r, onApri }) => (
  <button onClick={() => onApri(r.id)} data-testid={`richiamo-card-${r.id}`}
    className={`w-full text-left rounded-2xl border p-4 flex items-center gap-3 bg-white ${r.stato === 'aperto' ? 'border-red-300' : 'border-gray-200'}`}>
    <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${r.stato === 'aperto' ? 'bg-red-600' : 'bg-gray-300'}`}><Siren className="h-5 w-5 text-white" /></div>
    <div className="flex-1 min-w-0">
      <p className="font-semibold text-gray-900 truncate">{r.prodotto || '-'}</p>
      <p className="text-xs text-gray-600">n. {r.numero} · aperto il {dataIt(r.aperto_il)} · {preparazioni(r.bloccate)}</p>
    </div>
    <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${r.stato === 'aperto' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-600'}`}>{r.stato === 'aperto' ? 'APERTO' : 'CHIUSO'}</span>
    <ChevronRight className="h-5 w-5 text-gray-400" />
  </button>
);

export const RichiamiSection = () => {
  const [responsabile, setResponsabile] = useState(false);
  const [richiami, setRichiami] = useState(null);
  const [vista, setVista] = useState('elenco');
  const carica = useCallback(async () => {
    try { setRichiami((await haccpApi.get('/richiami')).richiami); } catch (e) { setRichiami([]); }
  }, []);
  useEffect(() => {
    carica();
    haccpApi.get('/richiami/permessi').then((p) => setResponsabile(p.responsabile)).catch(() => setResponsabile(false));
  }, [carica]);

  if (vista === 'nuovo') {
    return <div className="p-4 lg:p-6"><NuovoRichiamo onIndietro={() => setVista('elenco')} onCreato={(id) => { carica(); setVista(id); }} /></div>;
  }
  if (vista !== 'elenco') {
    return <div className="p-4 lg:p-6"><RichiamoDettaglio id={vista} responsabile={responsabile} onIndietro={() => setVista('elenco')} onCambiato={carica} /></div>;
  }
  return (
    <div className="p-4 lg:p-6 space-y-4" data-testid="richiami-section">
      <div className="bg-white rounded-2xl border border-gray-200 p-4 space-y-3">
        <h3 className="font-bold text-gray-900">Richiamo di un prodotto</h3>
        <p className="text-sm text-gray-600">Fotografa l'avviso o scrivi prodotto e lotto: l'app trova in quali DDT è arrivato e quali preparazioni lo contengono, le blocca e prepara il registro per l'ASL.</p>
        {responsabile ? (
          <button onClick={() => setVista('nuovo')} data-testid="richiami-nuovo-btn"
            className="w-full h-12 rounded-full bg-red-600 hover:bg-red-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors">
            <Plus className="h-5 w-5" />Nuovo richiamo
          </button>
        ) : <p className="text-xs text-gray-500" data-testid="richiami-solo-responsabile">Solo il responsabile apre e chiude i richiami.</p>}
      </div>
      {richiami === null && <div className="flex justify-center p-4"><Loader2 className="h-6 w-6 animate-spin text-gray-400" /></div>}
      {richiami?.length === 0 && <p className="text-sm text-gray-600 text-center" data-testid="richiami-vuoto">Nessun richiamo registrato.</p>}
      <div className="space-y-2">{(richiami || []).map((r) => <Card key={r.id} r={r} onApri={setVista} />)}</div>
    </div>
  );
};

export default RichiamiSection;
